import { normalizeBallNum, splitCsv, normalizeHistoryTone } from '@/utils/ballUtils'
import { formatHistoryDateLabel } from '@/utils/dateUtils'

const HK_COLOR_MAP = { 1: 'red', 2: 'blue', 3: 'green' }

export function mapMacauHistoryItem(raw) {
  if (!raw || typeof raw !== 'object' || !raw.openCode) return null
  const nums = splitCsv(raw.openCode)
  if (nums.length < 7) return null
  const waves = splitCsv(raw.wave)
  const zodiacs = splitCsv(raw.zodiac)
  const mainNumbers = nums.slice(0, 6).map((n, i) => ({
    value: normalizeBallNum(n),
    tone: normalizeHistoryTone(waves[i]),
    zodiac: zodiacs[i] != null ? String(zodiacs[i]) : '',
    element: ''
  }))
  const expectStr = raw.expect != null ? String(raw.expect) : ''
  const issueNum = parseInt(expectStr, 10) || 0
  const issueShort =
    expectStr.length >= 4
      ? String(parseInt(expectStr.slice(-3), 10) || expectStr.slice(-3))
      : expectStr
  const rowKey = `macau-${expectStr}`
  return {
    rowKey,
    expectFull: expectStr,
    issue: issueShort,
    issueNum,
    dateLabel: formatHistoryDateLabel(raw.openTime),
    mainNumbers,
    special: {
      value: normalizeBallNum(nums[6]),
      zodiac: zodiacs[6] != null ? String(zodiacs[6]) : '',
      element: '',
      tone: normalizeHistoryTone(waves[6])
    }
  }
}

export function mapRecordToRow(raw, index) {
  if (!raw || typeof raw !== 'object') return null
  if (
    Array.isArray(raw.nums) &&
    raw.nums.length >= 6 &&
    raw.special != null &&
    raw.special !== ''
  ) {
    const colors = Array.isArray(raw.colorList) ? raw.colorList : []
    const zodiacs = Array.isArray(raw.zodiacList) ? raw.zodiacList : []
    const elements = Array.isArray(raw.elementList) ? raw.elementList : []
    const mainNumbers = raw.nums.slice(0, 6).map((n, i) => ({
      value: normalizeBallNum(n),
      tone: normalizeHistoryTone(colors[i]),
      zodiac: zodiacs[i] != null ? String(zodiacs[i]) : '',
      element: elements[i] != null ? String(elements[i]) : ''
    }))
    const issueStr =
      raw.issueNo != null ? String(raw.issueNo) : raw.id != null ? String(raw.id) : ''
    const issueNum = parseInt(issueStr, 10)
    const dateLabel = formatHistoryDateLabel(raw.drawTime)
    const rowKey =
      raw.id != null
        ? `id-${raw.id}`
        : `${issueStr}-${raw.drawTime || index}`
    return {
      rowKey,
      issue: issueStr,
      issueNum: Number.isFinite(issueNum) ? issueNum : 0,
      dateLabel,
      mainNumbers,
      special: {
        value: normalizeBallNum(raw.special),
        zodiac: zodiacs[6] != null ? String(zodiacs[6]) : '',
        element: elements[6] != null ? String(elements[6]) : '',
        tone: normalizeHistoryTone(colors[6])
      }
    }
  }
  return null
}

export function mapHkHistoryRecordToRow(raw, index) {
  if (!raw || typeof raw !== 'object') return null
  const numberList = Array.isArray(raw.numberList) ? raw.numberList : []
  if (numberList.length < 7) return null

  const mainNumbers = numberList.slice(0, 6).map(n => ({
    value: normalizeBallNum(n.number),
    tone: HK_COLOR_MAP[n.color] || 'blue',
    zodiac: n.shengXiao || '',
    element: n.wuXing || ''
  }))

  const specialNum = numberList[6]
  const issueStr = raw.periodStr || String(raw.period || '')
  const issueNum = raw.period || 0
  const dateLabel = raw.lotteryTime || ''

  return {
    rowKey: `hkhist-${raw.id || index}`,
    issue: issueStr,
    issueNum: Number.isFinite(issueNum) ? issueNum : 0,
    dateLabel,
    mainNumbers,
    special: {
      value: normalizeBallNum(specialNum.number),
      zodiac: specialNum.shengXiao || '',
      element: specialNum.wuXing || '',
      tone: HK_COLOR_MAP[specialNum.color] || 'blue'
    }
  }
}

export function dedupeMacauMappedRows(mapped) {
  const seen = new Set()
  const out = []
  for (const r of mapped) {
    if (!r) continue
    const k = r.expectFull || String(r.issueNum)
    if (seen.has(k)) continue
    seen.add(k)
    out.push(r)
  }
  return out
}

export function filterMacauListByYear(list, year) {
  const y = Number(year)
  if (!Number.isFinite(y)) return list
  return list.filter(item => {
    if (!item || item.openTime == null || item.openTime === '') return false
    const d = new Date(String(item.openTime).replace(' ', 'T'))
    if (Number.isNaN(d.getTime())) return false
    return d.getFullYear() === y
  })
}

export function extractMacauDataList(res) {
  const body = res && res.data
  const data = body && body.data
  return Array.isArray(data) ? data : []
}
